<!--
/*******************************************************************************
*@ 컴포넌트명   : AutotrsaccHist.vue
*@ 컴포넌트설명 : 자동이체등록내역조회 
*@ 사용전문     : RBF0405F40 - 자동이체등록내역조회 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <common-grid
      ref="commonGrid"
      :list="RBF0405F40.chekTranGrid"
      :total-line-cnt="totalCnt"
      :scroll-event="true"
      pageType="autoTrsacc"
      @reSearch="RBF0405F40Call"
    >
      <template v-slot:list="data">
        <div class="item state">
          <div class="tit">
            {{ data.row.draweAcno }}
            <i
              class="icon icon-arrow-m-right"
              @click="goToDetail(data.row)"
            />
          </div>
          <template>
            <!-- 이체대기,이체진행,종료,해지 구분값 필요 -->
            <div
              v-if="data.row.stus == '0'"
              class="desc normal"
            >{{ /*이체대기*/ $t("MPAY-03-02-01-10") }}</div>
            <div
              v-else-if="data.row.stus == '1'"
              class="desc ing"
            >{{ /*이체진행*/ $t("MPAY-03-02-01-05") }}</div>
            <div
              v-else-if="data.row.stus == '2'"
              class="desc ending"
            >{{ /*종료*/ $t("MPAY-03-02-03-03") }}</div>
            <div v-else class="desc warning">{{ /*해지*/ $t("MPAY-03-02-03-04") }}</div>
          </template>
        </div>
        <div class="item name left">{{ data.row.draweAcnFname }}</div>
        <div class="item object">
          <div class="tit">{{ /* 이체금액 */ $t("MPAY-03-02-01-06") }}</div>
          <div class="desc">
            <span class="exchange-unit">{{ data.row.cncycd }}</span>
            <span class="amount" v-html="$num(data.row.trsaccAmt, null, true)"></span>
          </div>
        </div>

        <div class="item etc">
          <div class="tit">{{$t(/* 자동이체일 */"MPAY-03-02-08-10")}}</div>
          <div
            class="desc"
          >{{ $setTrsaccCyclDay(data.row.dwkDstcd, data.row.trsaccDd, data.row.trsaccCyclUnitDstcd, data.row.trsaccCyclUnitCnt) }}</div>
        </div>
        <div class="item etc">
          <div class="tit">{{ /*자동 이체 기간*/ $t("MPAY-03-02-01-08") }}</div>
          <div
            class="desc"
          >{{ $getGlobalDateFmt(data.row.trsaccStartYmd) }} ~ {{ $getGlobalDateFmt(data.row.trsaccEndYmd) }}</div>
        </div>
        <div class="inline-button-group" v-if="statusGubun == '1'">
          <button
            class="btn sm inline"
            @click="autoTrsaccUpdateFn(data.row)"
          >{{ /*자동 이체 변경*/ $t("MPAY-03-01-07-14") }}</button>
          <button
            class="btn sm inline"
            @click="autoTrsaccDeleteFn(data.row)"
          >{{ /*자동 이체 해지*/ $t("MPAY-03-02-01-09") }}</button>
        </div>
      </template>
    </common-grid>
    <section class="transfer">
      <popup
        :opened.sync="popupOpened"
        :title="/*자동이체등록 상세*/ $t('MPAY-03-02-02-01')"
        :use-header="true"
        :use-footer="true"
        class="popup"
      >
        <template #content>
          <article class="contents">
            <div class="account-info -type4">
              <span
                v-if="dtlData.stus == '0'"
                class="badge -type4"
              >{{ /*대기*/ $t("MPAY-03-02-01-15") }}</span>
              <span
                v-else-if="dtlData.stus == '1'"
                class="badge -type4"
              >{{ /*진행*/ $t("MPAY-03-02-03-02") }}</span>
              <span
                v-else-if="dtlData.stus == '2'"
                class="badge -type4"
              >{{ /*종료*/ $t("MPAY-03-02-03-03") }}</span>
              <span v-else class="badge -type4">{{ /*해지*/ $t("MPAY-03-02-03-04") }}</span>
              <div class="tit">{{ dtlData.prdctName }}</div>
              <div class="desc">
                <div class="item account">{{ dtlData.draweAcno }}</div>
              </div>
            </div>
            <dl class="dlist dlist-item--type4">
              <dt>{{ /* 출금계좌번호 */ $t("MPAY-03-02-02-03") }}</dt>
              <dd>{{ dtlData.acno }}</dd>
              <dt>{{ /* 이체금액 */ $t("MPAY-03-02-02-04") }}</dt>
              <dd class="right">
                <span class="exchange-unit">{{ dtlData.cncycd }}</span>
                <span class="amount" v-html="$num(dtlData.trsaccAmt, null, true)"></span>
              </dd>
            </dl>
            <dl class="dlist dlist-item--type4">
              <template v-if="siteCode != $config.SITECODE_OGAUC">
                <dt>{{ /* 입금은행 */ $t("MPAY-03-02-06-05") }}</dt>
                <dd>{{ dtlData.rcevnBnkName }}</dd>
              </template>
              <dt>{{ /* 입금계좌번호 */ $t("MPAY-03-02-06-06") }}</dt>
              <dd>{{ dtlData.draweAcno }}</dd>
              <dt>{{ /* 수취인 */ $t("MPAY-03-02-06-07") }}</dt>
              <dd>{{ dtlData.draweAcnFname }}</dd>
              <template v-if="siteCode == $config.SITECODE_OGMMR">
                <dt>{{ /*송금 목적*/ $t("MPAY-03-01-13-02") }}</dt>
              </template>
              <dd v-if="siteCode == $config.SITECODE_OGMMR">{{ dtlData.trsaccApctRefCtnt1 }}</dd>
              <!-- 송금 메모(목적)는 미얀마만! 
              <template v-else>
                <dt>{{ /*송금 메모*/ $t("MPAY-03-01-13-01") }}</dt>
              </template>
              
              -->
              <dt
                v-html="siteCode == $config.SITECODE_OGAUC ? 'Particulars' : $t('MPAY-03-01-11-08') /* 수취인 참조내용 */"
              ></dt>
              <dd>{{ dtlData.draweRefCtnt1 }}</dd>
              <template v-if="siteCode == $config.SITECODE_OGAUC">
                <dt>Code</dt>
                <dd>{{ dtlData.draweRefCtnt2 }}</dd>
                <dt>Reference</dt>
                <dd>{{ dtlData.draweRefCtnt3 }}</dd>
              </template>
              <dt>{{ /* 자동이체일 */ $t("MPAY-03-02-08-10") }}</dt>
              <dd>{{ $setTrsaccCyclDay(dtlData.dwkDstcd, dtlData.trsaccDd, dtlData.trsaccCyclUnitDstcd, dtlData.trsaccCyclUnitCnt) }}</dd>
              <template v-if="siteCode != $config.SITECODE_OGAUC">
                <dt>{{ /* 휴일인 경우 */ $t("MPAY-03-01-07-08") }}</dt>
                <dd>{{ $t(dtlData.holdyTrsaccDstcd + "_휴일이체구분코드") }}</dd>
              </template>
              <dt>{{ /* 이체시작일 */ $t("MPAY-03-02-08-12") }}</dt>
              <dd>{{ $getGlobalDateFmt(dtlData.trsaccStartYmd) }}</dd>
              <dt>{{ /* 이체종료일 */ $t("MPAY-03-02-02-14") }}</dt>
              <dd>{{ $getGlobalDateFmt(dtlData.trsaccEndYmd) }}</dd>
              <dt>{{/*차기 이체 영업일*/$t('MPAY-03-02-02-18')}}</dt>
              <!-- 차기 이체일 서버에서 받아오기 -->
              <dd>{{ $getGlobalDateFmt(dtlData.nxtrmTrsaccBzoprYmd)}}</dd>

              <dt>{{ /* 신청일 */ $t("MPAY-03-02-02-15") }}</dt>
              <dd>{{ $getGlobalDateFmt(dtlData.trsaccAplcnYmd) }}</dd>
            </dl>
          </article>
        </template>
        <template #footer>
          <div class="btn-area--full">
            <button class="btn icon gray" @click="popupClose()">
              <i class="icon icon-back" />
            </button>
            <template v-if="statusGubun == '1'">
              <button
                class="btn md normal"
                @click="autoTrsaccUpdateFn(dtlData)"
              >{{ /*자동 이체 변경*/ $t("MPAY-03-01-07-14") }}</button>
              <button
                class="btn md normal"
                @click="autoTrsaccDeleteFn(dtlData)"
              >{{ /*자동 이체 해지*/ $t("MPAY-03-02-01-09") }}</button>
            </template>
            <template v-else>
              <button class="btn md normal" @click="popupClose()">{{ /* 확인 */ $t("MCOM-0000003") }}</button>
            </template>
          </div>
        </template>
      </popup>
    </section>
  </article>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import CommonGrid from "@/components/page/common/CommonGrid";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getSessionCoprDstcd"]),
    ...mapFields(["siteCode"]),
    ...mapFields("transfer/autoTrsaccRegiHist", ["RBF0405F40", "autoTrsaccTermi", "autoTrsaccUpdate"]),
  },
  components: {
    CommonGrid,
  },
  props: {
    acno: String,
    statusGubun: String,
    stus: String, //이체상태 0:이체대기 1:이체진행 2:종료 3:해지
  },
  watch: {
    acno: function () {
      this.firstCall();
    },
  },
  mounted() {
    if (this.acno != "") {
      this.firstCall();
    }
  },
  data() {
    return {
      data: {},
      popupOpened: false,
      totalCnt: 0,
      call: true,
      dtlData: {},
    };
  },
  methods: {
    firstCall() {
      this.page = 1;
      this.RBF0405F40Call(this.page);
    },
    RBF0405F40Call(page) {
      if (this.call) {
        if (page == null) {
          if (this.page * 10 <= this.totalCnt) {
            this.page++;
          } else {
            return;
          }
        } else {
          this.page = 1;
        }
        this.call = false;
        let param = {
          dmndPageNo: this.page, //요청페이지번호(입력부)
          pageLineCnt: "10", //페이지라인수(입력부)
          acno: this.acno, //출금계좌번호
          statusGubun: this.statusGubun, //상태값	1:등록, 2:해지
          obaobDstic: "", //당타행구분	"": 전체, 1: 당행, 2: 타행
          inqueryDst: "1", //조회구분값	1:자동이체등록내역조회, 2:예약이체등록내역조회
        };
        /* API_RBF0405F40 - 자동이체등록내역조회 호출 */
        this.$post("/transfer/autotrsacc/AutoTrsaccRegiHistInqOut", param, this.RBF0405F40Suc);
      }
    },
    RBF0405F40Suc(res) {
      if (this.stus == "2" || this.stus == "3") {
        const list = [];
        res.outItem.chekTranGrid.forEach(item => {
          if (item.stus == this.stus) {
            list.push({
              ...item,
            });
          }
        });
        this.totalCnt = list.length;
        res.outItem.chekTranGrid = list;
      } else {
        this.totalCnt = res.outItem.totalLineCnt;
      }

      if (this.page === 1) {
        this.RBF0405F40.chekTranGrid = [
          //자동이체등록내역조회 호출 결과
          ...res.outItem.chekTranGrid,
        ];
      } else {
        this.RBF0405F40.chekTranGrid = [
          //자동이체등록내역조회 호출 결과
          ...this.RBF0405F40.chekTranGrid,
          ...res.outItem.chekTranGrid,
        ];
      }
      // dwkDstcd가 있는 경우 이건 시작일자로 가져온 것이기 때문에
      // 서버에서는 차기이체일은 제대로 내보내주므로 그걸 가지고 자동 이체 영업일 요일 계산하기
      if (this.RBF0405F40.chekTranGrid.length != 0) {
        for (var i = 0; i < this.RBF0405F40.chekTranGrid.length; i++) {
          if (this.RBF0405F40.chekTranGrid[i].dwkDstcd != "" || this.RBF0405F40.chekTranGrid[i].dwkDstcd != undefined) {
            this.RBF0405F40.chekTranGrid[i].dwkDstcd = this.moment(this.RBF0405F40.chekTranGrid[i].nxtrmPbhdayInclsnTrsaccYmd).utc().day() + 2;
          }
        }
      }

      this.$refs.commonGrid.changeList(this.RBF0405F40.chekTranGrid);

      this.call = true;
    },
    goToDetail(item) {
      this.dtlData = item;
      this.popupOpened = true;
    },
    autoTrsaccUpdateFn(item) {
      this.autoTrsaccUpdate = item;
      this.$router.push({ name: "autoTrsaccUpdateReq1" });
    },
    autoTrsaccDeleteFn(item) {
      if (item.cnclYn === "2") {
        alert(this.$t("G002-112")); //이미 해지 되었거나 등록되지 않은 계좌입니다.",
        return false;
      }
      this.autoTrsaccTermi = item;
      this.$router.push({ name: "autoTrsaccRegiHistDtlDelete" });
    },
    popupClose() {
      this.popupOpened = false;
    },
  },
};
</script>
